import React from "react";
import './style.scss'
const SectionTitle = ({ subTitle, title, description }) => {
    return (
        <div className="sectionTitle">
            <span>{subTitle}</span>
            <h2>{title}</h2>
            {description && <p>{description}</p>}
        </div>
    )
}
export default SectionTitle